export const PRODUCTS_STORE = 'PRODUCTS_STORE'

export const ABOUT_STORE = 'ABOUT_STORE'

export const SLIDER_STORE = 'SLIDER_STORE'

export const QM_STORE = 'QM_STORE'

export const CONTACT_STORE = 'CONTACT_STORE'